import * as Period from '../../../../constants/Period';
var MARTIAL_ART_PERIOD_MAP = {};
MARTIAL_ART_PERIOD_MAP[3900] = Period.NOT_STARTED;
MARTIAL_ART_PERIOD_MAP[3902] = Period.FIRST;
MARTIAL_ART_PERIOD_MAP[3903] = Period.SECOND;
MARTIAL_ART_PERIOD_MAP[3904] = Period.THIRD;
MARTIAL_ART_PERIOD_MAP[3905] = Period.FOURTH;
MARTIAL_ART_PERIOD_MAP[3906] = Period.FIFTH;
MARTIAL_ART_PERIOD_MAP[3901] = Period.FINISHED;
export default MARTIAL_ART_PERIOD_MAP;



// WEBPACK FOOTER //
// ./src/components/grid/sportGlossary/MartialArt/PeriodMap.js